import moment from "moment";

export const getEdad = (fechaNacFiliatorio, formatoFechaNac) => {
    const today = moment();
    const birthDate = moment(fechaNacFiliatorio, formatoFechaNac ? formatoFechaNac : 'YYYY-MM-DD');

    const edadAnios = today.diff(birthDate, 'years');
    // birthDate.add(edadAnios, 'years');

    const meses = edadAnios >= 5 ? today.diff(birthDate, 'months') : 0;
    // birthDate.add(meses, 'months');
    const dia = edadAnios < 5 ? today.diff(birthDate, 'days') : 0;

    return {
        edadAnios,
        meses,
        dia
    }
}

export const adaptDatosFiliatorios = ({ datosGeneralesRIByID }) => {
    const { datosFiliatorios } = datosGeneralesRIByID;
    const { edadAnios } = getEdad(datosFiliatorios?.fechaNacimiento);
    return [
        { key: 'N° HC', value: datosFiliatorios?.hC },
        { key: 'Nombre', value: datosFiliatorios?.nombre },
        { key: 'Apellido', value: datosFiliatorios?.apellido },
        { key: 'DNI N°', value: datosFiliatorios?.dNI },
        { key: 'Fecha nacimiento', value: moment(datosFiliatorios?.fechaNacimiento).format('DD/MM/YYYY') },
        { key: 'Edad', value: edadAnios },
        { key: 'Sexo', value: datosFiliatorios?.sexo.toUpperCase() },
        { key: 'Domicilio', value: datosFiliatorios?.domicilio },
        { key: 'Financiador', value: datosFiliatorios?.financiador },
        { key: 'N° afiliado', value: datosFiliatorios?.nroAfiliado },
        { key: 'Tel. de contacto', value: datosFiliatorios?.telContacto },
        { key: 'Familiar de contacto', value: datosFiliatorios?.familiarContacto },
        { key: 'Tel Familiar', value: datosFiliatorios?.telFamiliar },
        { key: 'Médico prescriptor', value: datosFiliatorios?.medicoPrescriptor }
    ]
}

export const adaptDireccionRI = ({ datosGeneralesRIByID }) => {
    return {
        domicilioRI: datosGeneralesRIByID?.datosFiliatorios?.domicilioRI,
        habitacionRI: datosGeneralesRIByID?.datosFiliatorios?.habitacionRI,
        localidadRI: datosGeneralesRIByID?.datosFiliatorios?.localidadRI,
        provinciaRI: datosGeneralesRIByID?.datosFiliatorios?.provinciaRI,
        codigoPostalRI: datosGeneralesRIByID?.datosFiliatorios?.codigoPostalRI
    }
}

export const adaptPaciente = ({ datosGeneralesRIByID }) => {

    const { datosFiliatorios } = datosGeneralesRIByID;
    const { edadAnios, meses, dia } = getEdad(datosFiliatorios?.fechaNacimiento);
    return {
        id: datosFiliatorios?.hC,
        hc: datosFiliatorios?.hC,
        nombre: datosFiliatorios?.nombre,
        apellido: datosFiliatorios?.apellido,
        dni: datosFiliatorios?.dNI,
        fechaNacimiento: moment(datosFiliatorios?.fechaNacimiento).format('DD/MM/YYYY'),
        edad: edadAnios,
        meses: meses,
        dia: dia,
        sexo: datosFiliatorios?.sexo.toUpperCase(),
        domicilio: datosFiliatorios?.domicilio,
        financiador: datosFiliatorios?.financiador,
        nroAfiliado: datosFiliatorios?.nroAfiliado,
        telContacto: datosFiliatorios?.telContacto,
        familiarContacto: datosFiliatorios?.familiarContacto,
        telFamiliar: datosFiliatorios?.telFamiliar,
        medicoPrescriptor: datosFiliatorios?.medicoPrescriptor,
    }
}